const formatCategory = category => {
  return {
    id: category.id,
    key: category.key,
    name: category.name,
    label: category.name,
    level: category.level,
    parentId: category.parent_id,
    nestedIds:
      category.children?.flatMap(
        child => child.children?.map(grandChild => grandChild.id) || child.id
      ) || [],
    children: category.children?.map(child => ({
      id: child.id,
      label: child.name,
      name: child.name,
      level: child.level,
      key: child.key,
      parentId: child.parent_id,
      nestedIds: child.children?.map(grandChild => grandChild.id) || [],
      children: child.children?.map(grandChild => ({
        id: grandChild.id,
        label: grandChild.name,
        key: grandChild.key,
        name: grandChild.name,
        level: grandChild.level,
        parentId: grandChild.parent_id
      }))
    }))
  };
};

export const getOrganisationB2CCategoriesResponseTransformer = ({data}) => {
  const categoriesById = {};

  const processCategory = category => {
    categoriesById[category.id] = formatCategory(category);
    if (category.children?.length) {
      category.children.forEach(processCategory);
    }
  };

  data?.categories?.forEach(processCategory);

  return {
    categories: data?.categories?.map(category => {
      return formatCategory(category);
    }),
    categoriesById
  };
};

export const getBenefitCategoriesResponseTransformer =
  getOrganisationB2CCategoriesResponseTransformer;
